import { useAppSelector } from '@/store'
import type { PLACEMENT } from '@/store/appSlice'

import StumpShadeStainingTooltip from './components/StumpShadeStainingTooltip'

interface KonvaFLStumpShadeStainingProps {
  placement: PLACEMENT
}

const KonvaFLStumpShadeStaining: React.FC<KonvaFLStumpShadeStainingProps> = ({
  placement,
}) => {
  const stumpShadeStainingRecipe = useAppSelector(
    (state) => state.fullLayering.stumpShadeRecipe,
  )

  if (!stumpShadeStainingRecipe?.[placement]) return null

  return (
    <>
      {Object.values(stumpShadeStainingRecipe[placement]).map((recipe: any) => (
        <StumpShadeStainingTooltip
          key={recipe?.input?.basecolor}
          input={recipe?.input}
          output={recipe?.output}
          tooltipPlacement={placement}
        />
      ))}
    </>
  )
}

export default KonvaFLStumpShadeStaining
